export const CellRenderType = {
  ACTIONS: 'actions',
  LINK: 'link',
  USER_AVATAR: 'user-avatar',
  THUMBNAIL: 'thumbnail',
  TITLE: 'title',
  BOOLEAN: 'boolean',
  DOCUMENT: 'document',
  DOCUMENTS: 'documents',
  ICON: 'icon',
  TAGS: 'tags',
  CUSTOM: 'custom'
};

export const SortOrder = {
  ASC: 'asc',
  DESC: 'desc'
};
